<template>
  <div class="flex align-items-center justify-content-center pt-3 pb-3">
    <PrimevueCard  class="sm:w-6 md:w-6 lg:w-5 xl:w-4">
      <template #title>UŽÍVATEĽ</template>
      <template #subtitle ><div class="mb-3 border-solid border-1 surface-border"></div></template>
      <template #content>
          
          <form @submit.prevent="submitHandler" name="userForm">
            <div class="field">
                <label for="first-name">Meno</label>
                <InputText class="w-full" 
                  :class="`${v$.user.firstName.$error ? 'bg-red-200' : ''}`"
                  :invalid="v$.user.firstName.$error"
                  v-model="this.user.firstName"
                  type="text"
                  name="first-name"
                  id="first-name"
                >
                </InputText>
                <div
                     v-for="(error, index) of v$.user.firstName.$errors"
                     :key="index"
                     class="text-sm font-italic text-red-400"
                >
                  {{ error.$message }}
                </div>
            </div>
            <div class="field">
              <label for="last-name">Priezvisko</label>
              <InputText class="w-full"
                :class="`${v$.user.lastName.$error ? 'bg-red-200' : ''}`"
                :invalid="v$.user.lastName.$error"
                v-model="this.user.lastName"
                type="text"
                name="last-name"
                id="last-name"
                >
              </InputText>
              <div
                    v-for="(error, index) of v$.user.lastName.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
              >
                {{ error.$message }}
              </div>
            </div>
            <div class="field">
              <label for="company">Spoločnosť</label>
              <InputText class="w-full"
                v-model="this.user.company"
                type="text"
                name="company"
                id="company"
                >
              </InputText>
            </div>  
            <div class="field">
              <label class="w-full" for="department">Oddelenie</label>
              <span v-tooltip.top=" 'Týmto vyberáš aj oprávnenia užívateľa' ">
                <PrimevueSelect
                    :disabled="!store.user.admin"
                    id="department"
                    v-model="this.selectDepartment"
                    :options="this.departOptions"
                    class="w-full"
                >
                    <template #value="slotProps">
                      <div>{{ slotProps.value.name }}</div>
                    </template>
                    <template #option="slotProps">
                        <div class="">
                          <div>{{ slotProps.option.name }}</div>
                        </div>
                    </template>
                </PrimevueSelect>
              </span>
            </div>
            <div class="field">
              <label for="email">E-mail</label>
              <InputText class="w-full"
                :class="`${v$.user.email.$error ? 'bg-red-200' : ''}`"
                :invalid="v$.user.email.$error"
                v-model="this.user.email"
                type="email"
                name="email"
                id="email"
                >
              </InputText>
              <div
                    v-for="(error, index) of v$.user.email.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
              >
                {{ error.$message }}
              </div>              
            </div>   
            <div class="field">
              <label for="phone">Mobil</label>
              <InputText class="w-full"
                :class="`${v$.user.phone.$error ? 'bg-red-200' : ''}`"
                :invalid="v$.user.phone.$error"
                v-model="this.user.phone"
                type="text"
                name="phone"
                id="phone"
                >
              </InputText>
              <div
                    v-for="(error, index) of v$.user.phone.$errors"
                    :key="index"
                    class="text-sm font-italic text-red-400"
              >
                {{ error.$message }}
              </div>
            </div>  

            <div class="flex align-items-center justify-content-center"> 
              <div v-if="!(this.user.id===0)" class="w-4 mb-2 flex align-items-center justify-content-start"> 
                <PrimevueCheckbox class="" v-model="this.changedPasswd" inputId="changedPasswd" name="changedPasswd" :binary="true"/>
                <label for="changedPasswd" class="ml-2">Zmeniť heslo</label>
              </div>
            </div>

            <!--
            <div v-if="this.changedPasswd" class="field">
              <label class="w-full" for="oldPasswd">Staré heslo</label>
              <PrimevuePassword v-model="this.user.oldPasswd"              
                        name="oldPasswd"
                        id="oldPasswd" 
                        promptLabel="Zadaj staré heslo" 
                        toggleMask
              />
            </div>
            -->
            <div v-if="this.user.id===0 || this.changedPasswd" class="field">
              <label class="w-full" for="passwd">{{this.changedPasswd ? "Nové heslo" : "Heslo"}}</label>
              <PrimevuePassword v-model="this.user.passwd"              
                        name="passwd"
                        id="passwd" 
                        promptLabel="Zadaj heslo (min. 8 znakov)" 
                        weakLabel="Príliš slabé" 
                        mediumLabel="Slabé" 
                        strongLabel="Silné" 
                        toggleMask />
            </div>
            <div v-if="this.user.id===0 || this.changedPasswd" class="field">
              <label class="w-full" for="repasswd">{{this.changedPasswd ? "Nové heslo znovu" : "Heslo znovu"}}</label>
              <PrimevuePassword v-model="this.user.repasswd"
                        :inputClass="`${v$.user.repasswd.$error ? 'bg-red-200' : ''}`"
                        :invalid="v$.user.repasswd.$error"            
                        name="repasswd"
                        id="repasswd" 
                        promptLabel="Zadaj heslo (min. 8 znakov)" 
                        weakLabel="Príliš slabé" 
                        mediumLabel="Slabé" 
                        strongLabel="Silné" 
                        toggleMask />
              <div
                        v-for="(error, index) of v$.user.repasswd.$errors"
                        :key="index"
                        class="text-sm font-italic text-red-400"
              >
                    {{ error.$message }}
              </div>                        
            </div>

            <div class="flex align-items-center justify-content-center"> 
              <div class="w-4 flex align-items-center justify-content-start"> 
                <PrimevueCheckbox :disabled="!store.user.admin" v-model="this.user.admin" inputId="admin" name="admin" :binary="true" @change="handleAdminChange"/>
                <label for="admin" class="ml-2">Správca systému</label>
              </div>
            </div>
            <div class="mt-3 mb-3 border-solid border-1 surface-border"></div>
            
            <div class="mt-2 flex flex-wrap justify-content-center gap-3">
                <PrimevueButton type="submit" label="Uložiť" text raised class="uppercase"/>
                <router-link :to="store.user.admin ? '/admin/users' : '/'">
                      <PrimevueButton label="Zrušiť" severity="danger" text raised class="uppercase"/>
                </router-link>
            </div>
          </form>
        </template>
    
    </PrimevueCard>
  </div>
  <ConfirmDialog></ConfirmDialog>
</template>


<script lang="ts">
import Security from "@/components/security";
import {store} from "@/components/store";
import notie from "notie/dist/notie";
import router from "@/router";
import PrimevuePassword from 'primevue/password';
import PrimevueCheckbox from 'primevue/checkbox';
import PrimevueButton from 'primevue/button';
import PrimevueSelect from 'primevue/dropdown';
import PrimevueCard from 'primevue/card';
import { email, required, helpers, minLength, alpha, sameAs  } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

const mustBe421 = (value : string) => !helpers.req(value) || value.startsWith('+421')

const requiredWhenChanged = (param) =>
  helpers.withParams(
    { type: 'requiredWhenChanged', value: param },
    (value:string) => !param || value != ""
  ) 

export default {
  name: "UserEdit",
  components: {
      PrimevuePassword,
      PrimevueCheckbox,
      PrimevueButton,
      PrimevueSelect,
      PrimevueCard,
  },
  data() {
    return {
      store,
      routeParams: null,
      dialogClosedByAccept: false,
      changedPasswd: false,
      selectDepartment: {id:1, name:"sklad"},
      departOptions: [],
      user: {
        id: 0,
        firstName: "",
        lastName: "",
        company: "",
        department: {},
        email: "",
        phone: "",
        passwd: "",
        repasswd: "",
        
        admin: false
      },

    }
  },
  setup () {
    return {
      v$: useVuelidate()
    }
  },
  validations () {
    return {
      user: {
        firstName: { required: helpers.withMessage('Meno nesmie byť prázdne', required),
                     minLength: helpers.withMessage('Meno musí obsahovať min. 2 znaky', minLength(2)),
                     },
        lastName:  { required: helpers.withMessage('Meno nesmie byť prázdne', required),
                     minLength: helpers.withMessage('Meno musí obsahovať min. 2 znaky', minLength(2)),
                     },             
        phone: { mustBe421: helpers.withMessage('Telefón musí začínať +421', mustBe421)},
        email: { email: helpers.withMessage('Nesprávny email', email)},
        passwd: { requiredWhenChanged: helpers.withMessage('Heslo musí byť vyplnené', requiredWhenChanged(this.changedPasswd))},
        repasswd: { sameAs : helpers.withMessage('Heslá musia byť rovnaké', sameAs(this.user.passwd))}
      }
    }
  },
  methods: {
    async submitHandler() {
      const result = await this.v$.$validate()
      if (!result) {
        console.log('Valid:', result)
        return
      }

      const userId = parseInt(String(this.routeParams.userId), 10)
      console.log('userId:', userId)
      //let depart = this.departOptions.filter(obj => obj.id == this.user.department)[0]  
      //console.log('Depart:', depart)
      const payload = {
        id: this.user.id,
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        company: this.user.company,
        department: this.selectDepartment,
        email:this.user.email,
        phone:this.user.phone,
        admin:this.user.admin,
        password:this.user.passwd,
        repassword:this.user.repasswd,
        
        active:true
      }

      let method = "POST"
      let url = "/v1/user/"
      if (userId > 0){
        method = "PUT"
        url = "/v1/user/" + userId +"?changedPasswd="+this.changedPasswd
      }

      fetch(store.Api_url + url, Security.requestOptions(method, payload))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              console.log("error:", responseData.data.message);
              this.$emit('error', responseData.data.message);
              notie.alert({
                type: 'error',
                text: responseData.data.message
              })
            } else {
              notie.alert({
                type: 'success',
                text: "Užívateľ uložený"
              })
              //this.user = responseData.data
              //this.selectDepartment = this.user.department
              //router.push("/admin/users");
              if (this.changedPasswd){
                router.push("/login");
              }else{
                this.loadData()
              }
             
            }
          })
          .catch((error) => {
            this.$emit('error', "Chyba pri uložení užívateľa" + error);
            notie.alert({
              type: 'error',
              text: "Chyba pri uložení užívateľa" + error
            })
          })

    },

    loadData(){

      if (parseInt(String(this.routeParams.userId), 10) > 0) {
        // editing an existing user
        const userId = String(this.routeParams.userId)

        fetch(store.Api_url + "/v1/user/" + userId, Security.requestOptions("GET"))
            .then((response) => response.json())
            .then((responseData) => {
              if (responseData.error) {
                //console.log("error:", responseData.data);
                this.$emit('error', responseData.data.message);
              } else {
                //console.log(responseData);
                this.user = responseData.data
                this.selectDepartment = this.user.department
                this.user.passwd = ''
                this.user.repasswd = ''
                this.user.oldPasswd = ''
                //if(this.user.admin === true){
                //  this.checkedAdmin = "checked"
                //}
              }
            })
            .catch((error) => {
              this.$emit('error', "Chyba pri načítaní užívateľa" + error);
        })
      }

      fetch(store.Api_url + "/v1/department?query=deleted:0", Security.requestOptions("GET"))
          .then((response) => response.json())
          .then((responseData) => {
            if (responseData.error) {
              //console.log("error:", responseData.data);
              //this.$emit('error', responseData.data);
            } else {
              //console.log("Demartments:",responseData.data);
              this.departOptions = responseData.data
            }
      })
    },

    validateForm() {
      this.isSubmitted = true; // Mark the form as submitted to show validation feedback
      this.isPhoneValid = this.user.phone.startsWith('+421');
      if(this.isPhoneValid) {
        return true
      }else{
        return false
      }
    },
    handleAdminChange(event) {
      //console.log("Checked:", event);
      
      if(event.target.checked === true){
        //if(confirm("Povoľujete tomuto užívateľovi plné práva nad systémom?")){
        //  this.user.admin = event.target.checked;
        //}else {
        //  this.user.admin = false
        //}
        this.dialogClosedByAccept = false;
        this.$confirm.require({
          message: 'Povoľujete tomuto užívateľovi plné práva nad systémom?',
          header: 'Povolenie plných práv',
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: "Áno",
          rejectLabel: "Nie",

          accept: () => {
            this.user.admin = event.target.checked;
            this.dialogClosedByAccept = true;
          },
          reject: () => {
            this.user.admin = false;
          },
          onHide: () => {
              if(!this.dialogClosedByAccept){
                this.user.admin = false;
              }
              this.dialogClosedByAccept = false;
          }

      });
      }else{
        this.user.admin = false
      }

    }
  },

  beforeRouteUpdate(to, from, next) {
        if (Security.requireToken()){
        this.routeParams = to.params
        store.selectModul = this.$route.path.split("/")[1]
        //console.log("Route update");
        //this.initSelectFilters()
        //this.loadLazyDataOrders(this.selectParams)

        this.loadData()  

        next()
      }
  },


  beforeMount() {
    //console.log("calling user")
    if (Security.requireToken()){
      this.routeParams = this.$route.params
      store.selectModul = this.$route.path.split("/")[1]
      
      if(!(store.user.id==this.routeParams.userId || store.user.admin===true)){
        //router.push("/")
        notie.alert({
          type: 'error',
          text: "Na túto akciu nemáte oprávnenia"
        })
      }

      this.loadData()

    }

  }
}
</script>



<style scoped>

</style>